export default function(tx) {
  if (tx.closest('div.autosize-wrapper')) { // prevents multiple initialization
    return;
  }
  
  // wrapping textarea and adding duplicate sibling
  let wrapper = document.createElement('div');
  wrapper.setAttribute('class', 'autosize-wrapper');
  let duplicate = document.createElement('div');

  duplicate.textContent = tx.value;
  tx.parentNode.insertBefore(wrapper, tx);
  wrapper.appendChild(tx);
  wrapper.appendChild(duplicate);
  tx.addEventListener('input', function(){ 
    duplicate.textContent = this.value;
  });
  // styling
  wrapper.style.display = 'grid';
  duplicate.style.whiteSpace = 'pre-wrap';
  duplicate.style.visibility = 'hidden';
  tx.style.resize = 'none';
  tx.style.overflow = 'hidden';
  // identical styling for duplicate
  let txComputedStyle = getComputedStyle(tx);
  ['borderWidth', 'fontFamily', 'fontSize',
    'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom',
    'marginLeft', 'marginRight', 'marginTop'
   ].forEach(prop => {
    duplicate.style[prop] = txComputedStyle[prop];
  });

  duplicate.style.marginBottom = parseInt(txComputedStyle.marginBottom) + parseInt(txComputedStyle.fontSize) + 'px';
  duplicate.style.gridArea =  tx.style.gridArea = '1 / 1 / 2 / 2';

}